import { useEffect, useState } from "react";
import SideBar from "../Components/SideBar";
import { GetBlogCommentApi } from "../callApi/blogComment";

export default function Blogcomment() {
  const [data, setData] = useState([]);

  useEffect(() => {
    GetBlogCommentApi("blogComment").then((res) => {
      setData(res);
      sessionStorage.setItem("blogCommentApi", JSON.stringify(res));
    });
  }, []);
  return (
    <div className="admin-shop-comments">
      <SideBar />
      <div className="admin-container">
          <h1>Blog Comments</h1>
       <br/>

          <table className="admin-shop-comments-table">
            <thead className="admin-comment-head">
              <tr className="admin-comment-row">
                <th>Title</th>
                <th>Name</th>
                <th>Email</th>
                <th>Message</th>
                <th>Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((item) => (
                  <tr className="admin-comment-row">
                    <td>{item.title}</td>
                    <td>{item.firstname}</td>
                    <td>{item.email}</td>
                    <td>{item.message}</td>
                    <td>{item.date}</td>
                    <td>{item.Status}</td>
                  </tr>
                ))
              ) : (
                <tr className="admin-comment-row">
                  <td>No records found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
  );
}
